import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-datameer",
  "use": "icon-datameer-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-datameer\"><path d=\"M16 4c6.627 0 12 5.373 12 12 0 2.202-.595 4.319-1.704 6.167a1.161 1.161 0 0 1-1.991-1.195A9.6 9.6 0 0 0 25.677 16c0-5.345-4.332-9.677-9.677-9.677S6.323 10.655 6.323 16s4.332 9.677 9.677 9.677a9.63 9.63 0 0 0 5.218-1.525 1.161 1.161 0 1 1 1.254 1.955A11.95 11.95 0 0 1 16 28C9.373 28 4 22.627 4 16S9.373 4 16 4m0 5.143a6.857 6.857 0 1 1 0 13.714 6.857 6.857 0 0 1 0-13.714\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol